import React from "react";

import Icon from "sulu-admin-bundle/components/Icon";

const OnAddEventNotes = ({
    setComponentToInsertInModal,
    setIsEditing,
    setEventDetailsToAdd,
    TOTAL_TIME_PLAYED,
    quarterSelected,
    EVENT_TYPES,
    setIsModalOpen,
    sideSelected,
    sideNotSelected,
    sides,
    backgroundColor,
    direction,
    goals,
    setGoals,
  }) => {
    return (
      <button
        style={{
          backgroundColor: "#fff",
          color: "black",
          borderRadius: 5,
          width: "35%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 130,
          fontSize: 15,
          fontWeight: 700,
          border: "2px solid black",
        }}
        onClick={() => {
          setComponentToInsertInModal(AddEventNotes);
          setIsEditing(false);
  
          setEventDetailsToAdd({
            type: {
              name: "Neuer Eintrag",
              background: "#fff",
              addComponentToOpen: AddEventNotes,
              editComponentToOpen: EditEventNotes,
            },
            timestamp: TOTAL_TIME_PLAYED,
            quarterSelected,
            home: sides["home"],
            away: sides["away"],
            sides,
            liveEvent: false,
            eventNotes: "",
          });
  
          setIsModalOpen(true);
        }}
      >
        <Icon name="su-pen" />
        <span
          style={{
            marginLeft: 4,
          }}
        >
          Neuer Eintrag
        </span>
      </button>
    );
};

export default OnAddEventNotes;